import { ArrowUpRight, Linkedin } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { waLink, LINKEDIN, srcSetFor } from "@/lib/content";

const STATS = [
  { label: "Produtores atendidos", value: "73" },
  { label: "Desde", value: "2021" },
  { label: "Municípios atendidos", value: "22" },
  { label: "Cadeias produtivas", value: "5" },
];

export const Authority = () => (
  <section id="equipe" data-testid="authority-section" className="grain relative bg-[#1B2F1D] py-8 text-[#F9F8F3] sm:py-14 md:py-36">
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:items-start lg:gap-10">
        <div className="lg:col-span-6">
          <Reveal><Overline light>Quem assina os trabalhos</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif text-4xl leading-[1.05] tracking-tight text-[#1A2218] sm:mt-8 sm:text-5xl lg:text-6xl">
              Cada documento sai assinado por quem <em className="text-[#8FC690]">esteve no campo.</em>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2">
              <p className="font-serif text-2xl sm:text-3xl">Lucas Melo</p>
              <p className="font-mono text-xs uppercase tracking-[0.15em] text-[#8FC690]">Engenheiro Civil e Agrônomo · CREA-RS 244.373</p>
            </div>
            <p className="mt-2 text-sm text-[#F9F8F3]/70">Sócio-fundador e responsável técnico</p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                data-testid="authority-whatsapp-btn"
                href={waLink("Olá Lucas! Gostaria de conversar sobre um serviço com a Melo Agro Engenharia.")}
                target="_blank"
                rel="noreferrer"
                className="group inline-flex items-center gap-3 rounded-full bg-[#F9F8F3] px-7 py-4 text-sm font-semibold text-[#16220F] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#8FC690]"
              >
                Falar com o Lucas no WhatsApp
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
              </a>
              <a
                data-testid="authority-linkedin"
                href={LINKEDIN}
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn de Lucas Melo"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-[#8FC690]/40 px-6 py-4 text-sm font-semibold text-[#F9F8F3] transition-colors duration-300 hover:bg-white/5"
              >
                <Linkedin className="h-4 w-4" /> LinkedIn
              </a>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:pl-8">
          <Reveal delay={0.15}>
            <div className="overflow-hidden rounded-[28px] rounded-tr-[120px] border border-[#8FC690]/25">
              <img
                src="/fotos/lucas-campo.webp"
                alt="Engenheiro Lucas Melo em vistoria de lavoura de soja na Metade Sul do RS"
                srcSet={srcSetFor("/fotos/lucas-campo.webp")}
                sizes="(min-width:1024px) 40vw, calc(100vw - 40px)"
                width={960}
                height={1280}
                loading="lazy"
                data-testid="authority-photo"
                className="aspect-[16/10] h-full w-full object-cover transition-transform duration-[1.4s] hover:scale-105 sm:aspect-[3/4]"
              />
            </div>
          </Reveal>
        </div>
      </div>

      <div className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-[24px] border border-[#8FC690]/25 bg-[#8FC690]/25 sm:mt-14 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={0.05 * i} className="bg-[#1B2F1D]">
            <div data-testid={`stat-band-${i + 1}`} className="flex h-full flex-col justify-between gap-2 p-4 sm:gap-4 sm:p-8">
              <p data-testid={`stat-value-${i + 1}`} className="font-serif text-2xl font-semibold text-[#F9F8F3] sm:text-5xl">{s.value}</p>
              <p className="text-sm leading-snug text-[#F9F8F3]/75">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
